//run command - npx react-scripts start
/* eslint-disable no-undef */
import React, { useState} from 'react';
import './MainPage.css';
// import ParticlesBg from './ParticlesBg';
import { Button } from './Button';
import { Link } from 'react-scroll';
import { Form } from 'react-bootstrap';
import emailjs from 'emailjs-com';
import * as pdfjsLib from "pdfjs-dist/build/pdf";
import 'pdfjs-dist/build/pdf.worker.min';

pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;


// Popup component
const ProjectPopup = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;
  
    return (
      <div className="popup-overlay" onClick={onClose}>
        <div className="popup-content" onClick={(e) => e.stopPropagation()}>
          <button className="close-btn" onClick={onClose}>×</button>
          {children}
        </div>
      </div>
    );
  };
  
// Chatbot component
// const Chatbot = () => {
//     const [isOpen, setIsOpen] = useState(false);
//     const [messages, setMessages] = useState([
//       { text: "Hello! I'm Srushti's chatbot. How can I help you today?", isBot: true },
//     ]);
//     const [inputText, setInputText] = useState("");
//     const [pdfContent, setPdfContent] = useState("");
//     const inputRef = useRef(null);
  
//     useEffect(() => {
//       loadPDF();
//     }, []);
  
//     const loadPDF = async () => {
//       const url = process.env.PUBLIC_URL + "/Resume_Srushti_Patel.pdf";
//       try {
//         const pdf = await pdfjsLib.getDocument(url).promise;
//         let fullText = "";
//         for (let i = 1; i <= pdf.numPages; i++) {
//           const page = await pdf.getPage(i);
//           const textContent = await page.getTextContent();
//           fullText += textContent.items.map((item) => item.str).join(" ") + " ";
//         }
//         setPdfContent(fullText.toLowerCase()); // Convert to lowercase for easier matching
//       } catch (error) {
//         console.error("Error loading PDF:", error);
//       }
//     };
  
//     const handleSendMessage = () => {
//       if (inputText.trim() !== "") {
//         setMessages([...messages, { text: inputText, isBot: false }]);
//         setInputText("");
  
//         setTimeout(() => {
//           const botReply = getBotReply(inputText);
//           setMessages((prevMessages) => [...prevMessages, { text: botReply, isBot: true }]);
//         }, 1000);
//       }
//     };
  
//     const handleKeyPress = (e) => {
//       if (e.key === "Enter") {
//         handleSendMessage();
//       }
//     };
  
//     const getBotReply = (userMessage) => {
//       const lowercaseMessage = userMessage.toLowerCase();
  
//       // Predefined responses
//       if (lowercaseMessage.includes("hello") || lowercaseMessage.includes("hi")) {
//         return "Hello! How can I assist you with Srushti's portfolio?";
//       } else if (lowercaseMessage.includes("skills")) {
//         return "Srushti is skilled in UI/UX design, full-stack web development, and application development using technologies like React.js, Angular, Node.js, MongoDB, and Python.";
//       } else if (lowercaseMessage.includes("contact")) {
//         return "You can contact Srushti at shrupatel07@gmail.com or +1 (249) 979-0722.";
//       } else if (pdfContent) {
//         console.log("Bot is searching the PDF...");
  
//         // Searching PDF content using keyword matching
//         const words = lowercaseMessage.split(" ");
//         const relevantSentences = pdfContent
//           .split(". ")
//           .filter((sentence) => words.some((word) => sentence.includes(word)));
  
//         if (relevantSentences.length > 0) {
//           return relevantSentences.slice(0, 3).join(". ") + "."; // Return up to 3 relevant sentences
//         }
//       }
  
//       return "I'm sorry, I couldn't find specific information about that in Srushti's resume. Can you ask about her skills, experience, or contact details?";
//     };
  
//     useEffect(() => {
//       if (isOpen) {
//         inputRef.current.focus();
//       }
//     }, [isOpen]);
  
//     return (
//       <div className="chatbot-container">
//         {!isOpen && (
//           <button className="chatbot-button" onClick={() => setIsOpen(true)}>
//             <i className="fas fa-robot"></i>
//           </button>
//         )}
//         {isOpen && (
//           <div className="chatbot-popup">
//             <div className="chatbot-header">
//               <h3 className="bothead">Conversation with Sru</h3>
//               <button className="bot-closeicon" onClick={() => setIsOpen(false)}>×</button>
//             </div>
//             <div className="chatbot-messages">
//               {messages.map((message, index) => (
//                 <div key={index} className={`message-container ${message.isBot ? "bot" : "user"}`}>
//                   <div className={`message-icon ${message.isBot ? "bot-icon" : "user-icon"}`}>
//                     {message.isBot ? <i className="fas fa-robot"></i> : <i className="fas fa-user"></i>}
//                   </div>
//                   <div className={`message ${message.isBot ? "bot-message" : "user-message"}`}>
//                     {message.text}
//                   </div>
//                 </div>
//               ))}
//             </div>
//             <div className="chatbot-input">
//               <input
//                 type="text"
//                 placeholder="Type a message..."
//                 value={inputText}
//                 onChange={(e) => setInputText(e.target.value)}
//                 onKeyPress={handleKeyPress}
//                 ref={inputRef}
//               />
//               <button className="bot-send" onClick={handleSendMessage}>
//                 <i className="fas fa-paper-plane"></i>
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     );
//   };
  

function HeroSection() {
    window.onload = function () {
        const ham = document.getElementById('hamburgerBtn');
        const head = document.getElementById('header');

        ham.addEventListener('click', () => {
            head.classList.toggle('open');
        });
    }

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm(`srushti-gmail`, `contact_srushti`, e.target, `qpJp_3btCZ7Xo-SJu`)
            .then((result) => {
                alert("Message Sent, I'll get back to you shortly", result.text);
                console.log("Message Sent, I'll get back to you shortly", result.text);
            },
                (error) => {
                    alert("An error occurred, Please try again", error.text);
                    console.log("Error... Please try again", error.text);
                });
        e.target.reset()
    };

    // const fileURL = 'https://srushtipatel.netlify.app/Srushti_Patel_Resume.pdf';

    // const downloadFileAtURL = (url) => {
    //     const fileName = url.split('/').pop()
    //     const aTag = document.createElement('a')
    //     aTag.href = url
    //     aTag.setAttribute('download', fileName)
    //     document.body.appendChild(aTag)
    //     aTag.click();
    //     aTag.remove();
    // }

    const [openProject, setOpenProject] = useState(null);

    const togglePopup = (projectId) => {
        setOpenProject(openProject === projectId ? null : projectId);
      };

    return (
        <div className="herosection">
            {/* Header Section */}
            <span id="hamburgerBtn" className="hamburgerBtn"><i class="fas fa-bars"></i></span>
            <header id="header" className="header">
                <nav className="side-nav">
                    <div className="logo-container">
                        <Link to="/" className="l-link">
                            <div className="logo-link">
                                <img src="./srushti_logo.png" alt="Loading..." className="menu-logo" />
                            </div>
                            <h4>Srushti Patel</h4>
                        </Link>
                    </div>
                    <div id="header-nav" className="snavbar navbar-collapse">
                        <ul className="navbar-nav">
                            <li className="nav-item"><Link smooth={true} to="intro-sec" className="nav-link" activeClass="active" spy={true}>HOME</Link></li>
                            <li className="nav-item"><Link smooth={true} to="about" className="nav-link" activeClass="active" spy={true}>ABOUT ME</Link></li>
                            <li className="nav-item"><Link smooth={true} to="services" className="nav-link" activeClass="active" spy={true}>WHAT I DO</Link></li>
                            <li className="nav-item"><Link smooth={true} to="resume" className="nav-link" activeClass="active" spy={true}>RESUME</Link></li>
                            <li className="nav-item"><Link smooth={true} to="portfolio" className="nav-link" activeClass="active" spy={true}>PORTFOLIO</Link></li>
                            <li className="nav-item"><Link smooth={true} to="contact" className="nav-link" activeClass="active" spy={true}>CONTACT</Link></li>
                        </ul>
                    </div>
                    <ul className="social">
                        <li className="s-sites"><a className="s-links" href="https://www.facebook.com/shrushti.7998" target="blank"><i class="fab fa-facebook-f "></i></a></li>
                        <li className="s-sites"><a className="s-links" href="https://www.linkedin.com/in/srushtipatel07/" target="blank"><i class="fab fa-linkedin-in "></i></a></li>
                        <li className="s-sites"><a className="s-links" href="https://github.com/shrush07" target="blank"><i class="fab fa-github "></i></a></li>
                        <li className="s-sites"><a className="s-links" href="https://twitter.com/Srushti_07" target="blank"><i class="fab fa-twitter"></i></a></li>
                    </ul>
                </nav>
            </header>

            {/* Intro Section */}
            <section id="intro-sec" className="intro-sec">
                <div className="intro-wrap">
                    <div className="in-row">
                        <div className="text-center">
                            <p className="intro-p">Welcome </p>
                            <p className="intro-p">I'm Srushti Patel</p>
                            <p className="intro-p">a</p>
                            <div className="string-wrapper">
                                {/* <div className="static-string">a</div> */}
                                <ul className="typed-strings">
                                    {/* <li><span>Srushti Patel.</span></li> */}
                                    <li><span>Full Stack Developer.</span></li>
                                    <li><span>Data Analyst.</span></li>
                                    <li><span>Front-End Engineer.</span></li>
                                    <li><span>Web Developer.</span></li>
                                    <li><span>Designer.</span></li>
                                </ul>
                            </div>
                            <h2><span className="typed"></span></h2>
                            <p className="intro-p" style={{ marginTop: '1rem' }}>based in Calgary, Canada.</p>
                            <div className="intro-btn">
                                <Link smooth to="contact">
                                    <Button className='btn' buttonStyle='btn--outline2' buttonSize='btn--large'>LET'S TALK</Button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <Link smooth to="about" class="scroll-down-arrow text-white smooth-scroll" style={{ cursor: 'pointer' }}>
                    <span class="animated"><i class="fa fa-chevron-down"></i></span>
                </Link>
            </section>

            {/* About Section */}
            <section id="about" className="about-sec">
                <div className="ab-container">
                    <div className="ab-heading">
                        <h2 className="ab-head">ABOUT ME</h2>
                        <p className="ab-ph">Know Me More
                            <span className="head-separator"></span>
                        </p>
                    </div>
                    <div className="ab-row">
                        <div className="ab-detail">
                            <h2 className="ab-head2">I'm
                                <span className="ab-hspan"> Srushti Patel </span>
                                a Full Stack Developer 
                            </h2>
                            <p className='ab-p'>
                            Hi, I'm Srushti - a Calgary-based Full Stack Developer, UI/UX Designer, and Data Analyst with 5+ years of experience building scalable products from concept to launch.
                            My expertise spans Java (Spring Boot, REST APIs, Azure), modern JavaScript/TypeScript frameworks (React, Angular, Node.js), UI/UX design (Figma, Adobe XD), and data analytics (Power BI, IBM Cognos, Python, SQL). I bridge engineering, design, and data to create solutions that are functional, intuitive, and measurable.
                            Notable projects include Puff & Sip, a SaaS platform I designed and developed end-to-end, and StockSense, a financial analytics application combining data insights with modern frontend experiences.
                            I hold an Azure AI Fundamentals certification and continuously expand my skills in AI-powered UX, cloud technologies, and data engineering.
                            Open to Full Stack Developer, UI/UX Designer, and Data Analyst opportunities in Calgary.</p>
                        </div>
                        <div className="ab-contact">
                            <div className="ab-cdetails">
                                <ul className="ab-cul">
                                    <li className="ab-cli">
                                        <span className="ab-cspan">Name:</span>
                                        Srushti Patel
                                    </li>
                                    <li className="ab-cli">
                                        <span className="ab-cspan">Email:</span>
                                        <a href="mailto:shrupatel07@gmail.com" className="ab-a">shrupatel07@gmail.com</a>
                                    </li>
                                    <li className="ab-cli">
                                        <span className="ab-cspan">Contact:</span>
                                        <a href="tel:2499790722" className="ab-c">+1 (249) 979-0722</a>
                                    </li>
                                    <li className="ab-cli b0">
                                        <span className="ab-cspan">From:</span>
                                        Calgary, Canada
                                    </li>
                                </ul>
                            {/* <div className="ab-btn">
                                //     <Button onClick={() => { downloadFileAtURL(fileURL) }} className='btn' buttonStyle='btn--primary' buttonSize='btn--medium'>DOWNLOAD CV</Button>
                                 </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Services Section */}
            <section id="services" className="services-sec">
                <div className="sr-container">
                    <div className="sr-heading">
                        <h2 className="sr-head">SERVICES</h2>
                        <p className="sr-ph">What I Do?
                            <span className="head-separator"></span>
                        </p>
                    </div>
                </div>
                <div className="sr-row">
                    <div className="sr-detail">
                        <div className="sr-row2">
                            <div className="sr-det">
                                <div className="fe-box">
                                    <div className="fe-icon">
                                        <i class="fas fa-pencil-ruler"></i>
                                    </div>
                                    <h3 className="srh">UI/UX Design</h3>
                                    <p class="sr-p">Defining the creative direction for your product - form, colors, and general feel
                                        based on key pieces.
                                    </p>
                                </div>
                            </div>
                            <div className="sr-det">
                                <div className="fe-box">
                                    <div className="fe-icon">
                                        <i class="fas fa-desktop"></i>
                                    </div>
                                    <h3 className="srh">Web Development</h3>
                                    <p class="sr-p">I design & develop web interfaces by understanding the needs of each project that
                                        are visually engaging and simple to use.
                                    </p>
                                </div>
                            </div>
                            <div className="sr-det">
                                <div className="fe-box">
                                    <div className="fe-icon">
                                        <i class="fas fa-palette"></i>
                                    </div>
                                    <h3 className="srh">Graphic Design</h3>
                                    <p class="sr-p">Graphic design is to assemble together images, motion graphics, or typography
                                        to create a piece of design.
                                    </p>
                                </div>
                            </div>
                            <div className="sr-det">
                                <div className="fe-box">
                                    <div className="fe-icon">
                                        <i class="fas fa-paint-brush"></i>
                                    </div>
                                    <h3 className="srh">Design & Develop</h3>
                                    <p class="sr-p">As a designer & developer, I understand the perfect user interface should look
                                        good and work even better.
                                    </p>
                                </div>
                            </div>
                        </div>
                    <div className="sr-row3">
                        <h2 className="srh2">Skills</h2>
                        <div className="sr-tools">
                            <div className="sr-tool">
                                <p className="srt-p">React JS
                                    <span className="tspan">85%</span>
                                </p>
                                <div className="sr-pbar">
                                    <div className="sr-pb" style={{ width: '85%' }}></div>
                                </div>
                                <p className="srt-p">Web Design
                                    <span className="tspan">90%</span>
                                </p>
                                <div className="sr-pbar">
                                    <div className="sr-pb" style={{ width: '90%' }}></div>
                                </div>
                                <p className="srt-p">JavaScript
                                    <span className="tspan">75%</span>
                                </p>
                                <div className="sr-pbar">
                                    <div className="sr-pb" style={{ width: '75%' }}></div>
                                </div>
                                <p className="srt-p">Node JS
                                    <span className="tspan">80%</span>
                                </p>
                                <div className="sr-pbar">
                                    <div className="sr-pb" style={{ width: '80%' }}></div>
                                </div>
                                <p className="srt-p">Spring Boot
                                    <span className="tspan">60%</span>
                                </p>
                                <div className="sr-pbar">
                                    <div className="sr-pb" style={{ width: '60%' }}></div>
                                </div>
                            </div>
                            <div className="sr-tool">
                                <p className="srt-p">HTML/CSS
                                    <span className="tspan">95%</span>
                                </p>
                                <div className="sr-pbar">
                                    <div className="sr-pb" style={{ width: '95%' }}></div>
                                </div>
                                <p className="srt-p">Angular JS
                                    <span className="tspan">70%</span>
                                </p>
                                <div className="sr-pbar">
                                    <div className="sr-pb" style={{ width: '70%' }}></div>
                                </div>
                                <p className="srt-p">Express JS
                                    <span className="tspan">75%</span>
                                </p>
                                <div className="sr-pbar">
                                    <div className="sr-pb" style={{ width: '75%' }}></div>
                                </div>
                                <p className="srt-p">Mongo DB
                                    <span className="tspan">70%</span>
                                </p>
                                <div className="sr-pbar">
                                    <div className="sr-pb" style={{ width: '70%' }}></div>
                                </div>
                                <p className="srt-p">Python
                                    <span className="tspan">40%</span>
                                </p>
                                <div className="sr-pbar">
                                    <div className="sr-pb" style={{ width: '40%' }}></div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="re-btn">
                        //     <Button onClick={() => { downloadFileAtURL(fileURL) }} className='btn' buttonStyle='btn--outline' buttonSize='btn--medium'>DOWNLOAD CV</Button>
                        // </div> */}
                    </div>
                    </div>
                </div>
            </section>

            {/* Resume Section */}
            <section id="resume" className="resume-sec">
                <div className="re-container">
                    <div className="re-heading">
                        <h2 className="re-head">SUMMARY</h2>
                        <p className="re-ph">Resume
                            <span className="head-separator"></span>
                        </p>
                    </div>
                    <div className="edu-sec">
                        <div className="edu-con">
                            <h2 className="edh">My Education</h2>
                            <div className="edu-container">
                                <p className="re-ep">12/2025 - 03/2026</p>
                                <h3 className="edh3">Junior Data Analyst Program</h3>
                                <p className="ed-cn">NPower Canada
                                    <span className="espan">Alberta, Canada</span>
                                </p>
                            {/* <p className="edu-d">Aggregate: 7.51 / 10 CGPA</p> */}
                            </div>
                            <div className="edu-container">
                                <p className="re-ep">2016 - 2020</p>
                                <h3 className="edh3">Computer Science and Engineering</h3>
                                <p className="ed-cn">Parul University
                                    <span className="espan">Gujarat, India</span>
                                </p>
                                <p className="edu-d">Aggregate: 7.51 / 10 CGPA</p>
                            </div>
                            <div className="edu-container">
                                <p className="re-ep">2014 - 2016</p>
                                <h2 className="edh3">Secondary Education</h2>
                                <p className="ed-cn">Rudra School of Science
                                    <span className="espan">Gujarat, India</span>
                                </p>
                                <p className="edu-d">Aggregate: 60.02%</p>
                            </div>
                            <div className="edu-container">
                                <p className="re-ep">2002 - 2014</p>
                                <h2 className="edh3">Primary Education</h2>
                                <p className="ed-cn">Auxilium Convent High School
                                    <span className="espan">Gujarat, India</span>
                                </p>
                                <p className="edu-d">Aggregate: 81.07%</p>
                            </div>
                        </div>
                        <div className="edu-con">
                            <h2 className="edh">My Experience</h2>
                            <div className="edu-container">
                                <p className="re-ep">11/2025 - Present</p>
                                <h2 className="edh3">Digital Solutions Specialist</h2>
                                <p className="ed-cn">Sansh Tech Inc
                                    <span className="espan">Calgary, Canada.</span>
                                </p>
                                <p className="edu-d">Manage client SEO by maintaining Google rankings, optimizing website speed, and delivering monthly performance reports.</p>
                            </div>
                            <div className="edu-container">
                                <p className="re-ep">04/2022 - 10/2025</p>
                                <h2 className="edh3">Full Stack Developer</h2>
                                <p className="ed-cn">Ingenious Technologies
                                    <span className="espan">Gujarat, India.</span>
                                </p>
                                <p className="edu-d">Developed web apps using ReactJS, NodeJS, and MongoDB, handling both front-end and back-end solutions.</p>
                            </div>
                            <div className="edu-container">
                                <p className="re-ep">10/2024 - 02/2025</p>
                                <h2 className="edh3">UI UX Designer Intern</h2>
                                <p className="ed-cn">GAO Tek Inc
                                    <span className="espan">Ontario, Canada.</span>
                                </p>
                                <p className="edu-d">Developed brand guidelines that maintained design consistency across digital platforms.</p>
                            </div>
                            <div className="edu-container">
                                <p className="re-ep">12/2020 - 03/2022</p>
                                <h2 className="edh3">UI UX Developer</h2>
                                <p className="ed-cn">One5 Digital
                                    <span className="espan">Melbourne, Australia.</span>
                                </p>
                                <p className="edu-d">Designed interactive UIs, conducted usability testing, and created prototypes with Figma and Adobe XD.</p>
                            </div>
                            <div className="edu-container">
                                <p className="re-ep">05/2019 - 07/2019</p>
                                <h2 className="edh3">Internship</h2>
                                <p className="ed-cn">RAV infotech
                                    <span className="espan">Gujarat, India</span>
                                </p>
                                <p className="edu-d">Contributed to web development using .NET and JavaScript, focusing on front-end tasks and web design best practices.</p>
                            </div>
                        </div>
                    </div>
                    <div className="sr-row3">
                            <h2 className="srh2">Tools</h2>
                            <div className="sr-tools">
                                <div className="sr-tool">
                                    <p className="srt-p">Figma
                                        <span className="tspan">80%</span>
                                    </p>
                                    <div className="sr-pbar">
                                        <div className="sr-pb" style={{ width: '80%' }}></div>
                                    </div>
                                    <p className="srt-p">Adobe XD
                                        <span className="tspan">75%</span>
                                    </p>
                                    <div className="sr-pbar">
                                        <div className="sr-pb" style={{ width: '75%' }}></div>
                                    </div>
                                    <p className="srt-p">Sketch
                                        <span className="tspan">60%</span>
                                    </p>
                                    <div className="sr-pbar">
                                        <div className="sr-pb" style={{ width: '60%' }}></div>
                                    </div>
                                    <p className="srt-p">After Effect
                                        <span className="tspan">50%</span>
                                    </p>
                                    <div className="sr-pbar">
                                        <div className="sr-pb" style={{ width: '50%' }}></div>
                                    </div>
                                </div>
                                <div className="sr-tool">
                                    <p className="srt-p">Adobe Photoshop
                                        <span className="tspan">80%</span>
                                    </p>
                                    <div className="sr-pbar">
                                        <div className="sr-pb" style={{ width: '80%' }}></div>
                                    </div>
                                    <p className="srt-p">Adobe Illustrator
                                        <span className="tspan">85%</span>
                                    </p>
                                    <div className="sr-pbar">
                                        <div className="sr-pb" style={{ width: '85%' }}></div>
                                    </div>
                                    <p className="srt-p">InDesign
                                        <span className="tspan">60%</span>
                                    </p>
                                    <div className="sr-pbar">
                                        <div className="sr-pb" style={{ width: '60%' }}></div>
                                    </div>
                                    <p className="srt-p">Canva
                                        <span className="tspan">90%</span>
                                    </p>
                                    <div className="sr-pbar">
                                        <div className="sr-pb" style={{ width: '90%' }}></div>
                                    </div>
                                </div>
                            </div>
                    </div>
                    <div className="certifications">
                        <h2 className="srh2">Certifications</h2>
                        <div className="cr-details">
                            <div className="cr-names">
                                <div className="cr-name">
                                    <p className="srt-p">• Azure AI Fundamentals Professional Certificate by Microsoft</p>
                                </div>
                                <div className="cr-name">
                                    <p className="srt-p">• Search Engine Optimization Professional Certificate by Moz</p>
                                </div>
                                <div className="cr-name">
                                    <p className="srt-p">• Machine Learning and AI Foundations by LinkedIn</p>
                                </div>
                                <div className="cr-name">
                                    <p className="srt-p">• Predictive Analytics Essential Training: Data Mining by LinkedIn</p>
                                </div>
                                <div className="cr-name">
                                    <p className="srt-p">• Machine Learning Foundations by LinkedIn</p>
                                </div>
                                <div className="cr-name">
                                    <p className="srt-p">• Learning Data Analytics by LinkedIn</p>
                                </div>
                            </div>
                            
                            <div className="cr-names">
                                <div className="cr-name">
                                    <p className="srt-p">• Data Analyst Professional Certificate by IBM</p>
                                </div>
                                <div className="cr-name">
                                    <p className="srt-p">• Career Essentials in Data Analysis by Microsoft and LinkedIn</p>
                                </div>
                                <div className="cr-name">
                                    <p className="srt-p">• AWS Cloud Practitioner Essentials by AWS Training</p>
                                </div>
                                <div className="cr-name">
                                    <p className="srt-p">• Advanced Google Analytics by Google</p>
                                </div>
                                <div className="cr-name">
                                    <p className="srt-p">• Foundations of UX Design by Google</p>
                                </div>
                                <div className="cr-name">
                                    <p className="srt-p">• Cybersecurity for Business by Coursera</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div class="re-btn">
                    //     <Button onClick={() => { downloadFileAtURL(fileURL) }} className='btn' buttonStyle='btn--primary' buttonSize='btn--medium'>DOWNLOAD CV</Button>
                    // </div> */}
                </div>
            </section>

            {/* Portfolio Section */}
            <section id="portfolio" className="portfolio-sec">
                <div className="pr-container">
                    <div className="pr-heading">
                        <h2 className="pr-head">PORTFOLIO</h2>
                        <p className="pr-ph">My Work
                            <span className="head-separator"></span>
                        </p>
                    </div>
                    <div className="portfolio-gallery">
                        <input type="radio" id="All" name="categories" value="All" defaultChecked />
                        <input type="radio" id="Development" name="categories" value="Development" />
                        <input type="radio" id="Design" name="categories" value="Design" />
                        <input type="radio" id="Brand" name="categories" value="Brand" />
                        <input type="radio" id="Animation" name="categories" value="Animation" />
                        <ol className="filters">
                            <li className="lbl">
                                <label for="All">All</label>
                            </li>
                            <li className="lbl">
                                <label for="Development">Development</label>
                            </li>
                            <li className="lbl">
                                <label for="Design">Design</label>
                            </li>
                            <li className="lbl">
                                <label for="Brand">Brand</label>
                            </li>
                            <li className="lbl">
                                <label for="Animation">Animation</label>
                            </li>
                        </ol>
                        <div className="project-wrapper">
                        <ol className="posts"><li className="post post-categories" data-category="Development">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="puff_sip.gif" alt="Loading..." onClick={() => togglePopup('project2')}/>
                                    </figure>
                                </article>
                            </li>
                            <ProjectPopup isOpen={openProject === 'project2'} onClose={() => togglePopup('project2')}>
                                {/* <h2>Puff & Sip</h2> */}
                                <img className="pg-img" src="puff_sip.gif" alt="Loading..." />
                                <p className='pro-p'>Tools Used: Figma, Angular, Node.js with Express, MongoDB<br/>
                                    Responsibility: Designed and developed a scalable e-commerce platform. Created UI/UX designs in Figma, implemented the front end using Angular, and developed backend operations with Node.js and Express. Managed the database with MongoDB. Focused on optimizing website responsiveness and backend efficiency, resulting in reduced load times and increased user engagement.​
                                </p>
                            </ProjectPopup>

                            <li className="post post-categories" data-category="Brand">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="ingenious_studiio_logo.png" alt="Loading..." style={{ border: '0.5px solid #749ba8' }} onClick={() => togglePopup('project1')}/>
                                    </figure>
                                </article>
                            </li>
                            <ProjectPopup isOpen={openProject === 'project1'} onClose={() => togglePopup('project1')}>
                                {/* <h2>Ingenious Studio</h2> */}
                                <img className="pg-img" src="ingenious_studiio_logo.png" alt="Loading..." style={{ border: '0.5px solid #749ba8' }}/>
                            </ProjectPopup>

                            <li className="post post-categories" data-category="Design">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="Biovatika.gif" alt="Loading..." onClick={() => togglePopup('project4')}/>
                                    </figure>
                                </article>
                            </li>
                            <ProjectPopup isOpen={openProject === 'project4'} onClose={() => togglePopup('project4')}>
                                {/* <h2>Biovatika</h2> */}
                                <img className="pg-img" src="Biovatika.gif" alt="Loading..." />
                                <p className='pro-p'>Tools Used: Figma<br/>
                                    Responsibility: Designed an intuitive and user-friendly e-commerce application aimed at enhancing accessibility and user engagement. Focused on optimizing the UI/UX for seamless product browsing and purchasing experiences, leading to increased customer satisfaction and sales.​
                                </p>
                            </ProjectPopup>

                            <li className="post post-categories" data-category="Brand">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="Ingenious_Tech_Logo.png" alt="Loading..." style={{ border: '0.5px solid #749ba8' }} onClick={() => togglePopup('project3')}/>
                                    </figure>
                                </article>
                            </li>
                            <ProjectPopup isOpen={openProject === 'project3'} onClose={() => togglePopup('project3')}>
                                {/* <h2>Ingenious Technologies</h2> */}
                                <img className="pg-img" src="Ingenious_Tech_Logo.png" alt="Loading..." />
                            </ProjectPopup>

                            <li className="post post-categories" data-category="Development">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="Flowtrack.gif" alt="Loading..." onClick={() => togglePopup('project26')}/>
                                    </figure>
                                </article>
                            </li>
                            <ProjectPopup isOpen={openProject === 'project26'} onClose={() => togglePopup('project26')}>
                                {/* <h2>Puff & Sip</h2> */}
                                <img className="pg-img" src="Flowtrack.gif" alt="Loading..." />
                                <p className='pro-p'>Tools Used: Java 17, Spring Boot, Spring Data JPA, H2/PostgreSQL, HTML/CSS/JavaScript<br/>
                                    Responsibility: Built a Spring Boot workflow system with REST APIs, DB persistence, and browser UI for task tracking.​
                                </p>
                            </ProjectPopup>

                            <li className="post post-categories" data-category="Brand">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="Birchwood_Deli_&_Liquor_logo.png" alt="Loading..." style={{ border: '0.5px solid #749ba8' }} onClick={() => togglePopup('project5')}/>
                                    </figure>
                                </article>
                            </li>
                            <ProjectPopup isOpen={openProject === 'project5'} onClose={() => togglePopup('project5')}>
                                {/* <h2>Birchwood Deli & Liquor</h2> */}
                                <img className="pg-img" src="Birchwood_Deli_&_Liquor_logo.png" alt="Loading..." />
                            </ProjectPopup>

                            <li className="post post-categories" data-category="Development">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="ingenious_tech.gif" alt="Loading..."  onClick={() => togglePopup('project6')} />
                                    </figure>
                                </article>
                            </li>
                            <ProjectPopup isOpen={openProject === 'project6'} onClose={() => togglePopup('project6')}>
                                {/* <h2>Ingenious Technologies</h2> */}
                                <img className="pg-img" src="ingenious_tech.gif" alt="Loading..." />
                                <p className='pro-p'>Tools Used: Figma, WordPress<br/>
                                    Responsibility: Designed and developed a corporate website for a software company. Created wireframes and prototypes in Figma, focusing on user experience and interface design. Developed the site using WordPress, ensuring a responsive and user-friendly interface that effectively showcases the company's services and products.
                                </p>
                            </ProjectPopup>
                            
                            <li className="post post-categories" data-category="Brand">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="bluepac_logo.png" alt="Loading..." style={{ border: '0.5px solid #749ba8' }} onClick={() => togglePopup('project7')}/>
                                    </figure>
                                </article>
                            </li>
                            <ProjectPopup isOpen={openProject === 'project7'} onClose={() => togglePopup('project7')}>
                                {/* <h2>Bluepac</h2> */}
                                <img className="pg-img" src="bluepac_logo.png" alt="Loading..." />
                            </ProjectPopup>
                            
                            <li className="post post-categories" data-category="Development">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="stocksense.gif" alt="Loading..." onClick={() => togglePopup('project8')}/>
                                    </figure>
                                </article>
                            </li>
                            <ProjectPopup isOpen={openProject === 'project8'} onClose={() => togglePopup('project8')}>
                                {/* <h2>StockSense</h2> */}
                                <img className="pg-img" src="stocksense.gif" alt="Loading..." />
                                <p className='pro-p'>Tools Used: Python, Streamlit, Yahoo finance, Prophet, Power BI<br/>
                                    Responsibility: Build a stock prediction app using Python, Prophet, and Yfinance with a Streamlit interface to visualize trends interactively. Used Advanced Excel and Power Query for data cleaning and initial Analysis, and created a Power BI dashboard to compare predicted vs actual stock performance. 
                                </p>
                            </ProjectPopup>
                            
                            <li className="post post-categories" data-category="Brand">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="ingenious_technology_logo.png" alt="Loading..." onClick={() => togglePopup('project9')}/>
                                    </figure>
                                </article>
                            </li>
                            <ProjectPopup isOpen={openProject === 'project9'} onClose={() => togglePopup('project9')}>
                                {/* <h2>Ingenious Technologies</h2> */}
                                <img className="pg-img" src="ingenious_technology_logo.png" alt="Loading..." />
                            </ProjectPopup>
                            
                            <li className="post post-categories" data-category="Development">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="kerry.gif" alt="Loading..." onClick={() => togglePopup('project10')}/>
                                    </figure>
                                </article>
                            </li>
                            <ProjectPopup isOpen={openProject === 'project10'} onClose={() => togglePopup('project10')}>
                                {/* <h2>Kerry</h2> */}
                                <img className="pg-img" src="kerry.gif" alt="Loading..." />
                                <p className='pro-p'>Tools Used: Figma, WordPress<br/>
                                    Responsibility: Designed a professional and visually appealing website for a public relations firm. Emphasized the firm's brand identity and services through thoughtful layout and design elements, facilitating better client engagement and communication.​Developed the site using WordPress, ensuring a responsive and user-friendly interface that effectively showcases the company's services.
                                </p>
                            </ProjectPopup>
                            
                            <li className="post post-categories" data-category="Brand">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="relish_developers_logo.png" alt="Loading..." style={{ border: '0.5px solid #749ba8' }} onClick={() => togglePopup('project11')}/>
                                    </figure>
                                </article>
                            </li>
                            <ProjectPopup isOpen={openProject === 'project11'} onClose={() => togglePopup('project11')}>
                                {/* <h2>Relish Developers</h2> */}
                                <img className="pg-img" src="relish_developers_logo.png" alt="Loading..." />
                            </ProjectPopup>
                            
                            <li className="post post-categories" data-category="Design">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="Konsarutanto.gif" alt="Loading..." onClick={() => togglePopup('project12')}/>
                                    </figure>
                                </article>
                            </li>
                            <ProjectPopup isOpen={openProject === 'project12'} onClose={() => togglePopup('project12')}>
                                {/* <h2>Konsarutanto</h2> */}
                                <img className="pg-img" src="Konsarutanto.gif" alt="Loading..." />
                                <p className='pro-p'>Tools Used: Figma<br/>
                                    Responsibility: Designed an intuitive and user-friendly learning platform to enhance accessibility and engagement. Optimized the UI/UX for seamless content delivery, improving course navigation and increasing user retention.
                                </p>
                            </ProjectPopup>
                            
                            <li className="post post-categories" data-category="Brand">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="inteurb_logo.png" alt="Loading..." onClick={() => togglePopup('project13')}/>
                                    </figure>
                                </article>
                            </li>
                            <ProjectPopup isOpen={openProject === 'project13'} onClose={() => togglePopup('project13')}>
                                {/* <h2>Inteur</h2> */}
                                <img className="pg-img" src="inteurb_logo.png" alt="Loading..." />
                            </ProjectPopup>

                            <li className="post post-categories" data-category="Development">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="astropushpa.gif" alt="Loading..." onClick={() => togglePopup('project14')}/>
                                    </figure>
                                </article>
                            </li>
                            <ProjectPopup isOpen={openProject === 'project14'} onClose={() => togglePopup('project14')}>
                                {/* <h2>Astro Pushpa</h2> */}
                                <img className="pg-img" src="astropushpa.gif" alt="Loading..." />
                                <p className='pro-p'>Tools Used: Figma, WordPress<br/>
                                    Responsibility: Designed an intuitive and user-friendly application aimed at enhancing accessibility and user engagement. Focused on optimizing the UI/UX for seamless services browsing experiences, leading to increased customer satisfaction.​
                                </p>
                            </ProjectPopup>
                            
                            <li className="post post-categories" data-category="Brand">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="divmya_mono.png" alt="Loading..." onClick={() => togglePopup('project15')} style={{ border: '0.5px solid #749ba8' }}/>
                                    </figure>
                                </article>
                            </li>
                            <ProjectPopup isOpen={openProject === 'project15'} onClose={() => togglePopup('project15')}>
                                {/* <h2>DivMya</h2> */}
                                <img className="pg-img" src="divmya_mono.png" alt="Loading..." />
                            </ProjectPopup>
                            
                            <li className="post post-categories" data-category="Development">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="SuccessSquare.gif" alt="Loading..." onClick={() => togglePopup('project16')}/>
                                    </figure>
                                </article>
                            </li>
                            <ProjectPopup isOpen={openProject === 'project16'} onClose={() => togglePopup('project16')}>
                                {/* <h2>Success Square</h2> */}
                                <img className="pg-img" src="SuccessSquare.gif" alt="Loading..." />
                                <p className='pro-p'>Tools Used: WordPress<br/>
                                    Responsibility: Developed a professional website for a visa solutions company using WordPress. Ensured the site effectively communicates the company's services and provides an easy-to-navigate interface for potential clients seeking visa assistance.
                                </p>
                            </ProjectPopup>
                            
                            <li className="post post-categories" data-category="Brand">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="stocksense_logo.png" alt="Loading..."  onClick={() => togglePopup('project17')}/>
                                    </figure>
                                </article>
                            </li>
                            <ProjectPopup isOpen={openProject === 'project17'} onClose={() => togglePopup('project17')}>
                                {/* <h2>Ingenious Crafting</h2> */}
                                <img className="pg-img" src="stocksense_logo.png" alt="Loading..." />
                            </ProjectPopup>
                            
                            {/* <li className="post post-categories" data-category="Brand">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="hello_foody_logo.png" alt="Loading..." />
                                    </figure>
                                </article>
                            </li> */}
                            <li className="post post-categories" data-category="Development">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="beardog.gif" alt="Loading..." onClick={() => togglePopup('project18')}/>
                                    </figure>
                                </article>
                            </li>
                            <ProjectPopup isOpen={openProject === 'project18'} onClose={() => togglePopup('project18')}>
                                {/* <h2>Bear Dog Walking Services</h2> */}
                                <img className="pg-img" src="beardog.gif" alt="Loading..." />
                                <p className='pro-p'>Tools Used: Adobe XD, WordPress<br/>
                                    Responsibility: Designed the user interface in Adobe XD and developed the website in WordPress for a dog walking service provider. Focused on creating a friendly and approachable design that appeals to pet owners, with easy navigation to book services and learn about offerings.
                                </p>
                            </ProjectPopup>
                            
                            <li className="post post-categories" data-category="Brand">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="water_doctor_logo.png" alt="Loading..." onClick={() => togglePopup('project19')}/>
                                    </figure>
                                </article>
                            </li>
                            <ProjectPopup isOpen={openProject === 'project19'} onClose={() => togglePopup('project19')}>
                                {/* <h2>Water Doctor</h2> */}
                                <img className="pg-img" src="water_doctor_logo.png" alt="Loading..." />
                            </ProjectPopup>
                            
                            <li className="post post-categories" data-category="Brand">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="snh_mono.png" alt="Loading..." style={{ border: '0.5px solid #749ba8' }} onClick={() => togglePopup('project20')}/>
                                    </figure>
                                </article>
                            </li>
                            <ProjectPopup isOpen={openProject === 'project20'} onClose={() => togglePopup('project20')}>
                                {/* <h2>S & H Monogram</h2> */}
                                <img className="pg-img" src="snh_mono.png" alt="Loading..." />
                            </ProjectPopup>
                            
                            <li className="post post-categories" data-category="Brand">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="ingenious_architects_logo.png" alt="Loading..." onClick={() => togglePopup('project21')}/>
                                    </figure>
                                </article>
                            </li>
                            <ProjectPopup isOpen={openProject === 'project21'} onClose={() => togglePopup('project21')}>
                                {/* <h2>Ingenious Architects</h2> */}
                                <img className="pg-img" src="ingenious_architects_logo.png" alt="Loading..." />
                            </ProjectPopup>
                            
                            <li className="post post-categories" data-category="Development">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="srushti_patel.gif" alt="Loading..." onClick={() => togglePopup('project22')}/>
                                    </figure>
                                </article>
                            </li>
                            <ProjectPopup isOpen={openProject === 'project22'} onClose={() => togglePopup('project22')}>
                                {/* <h2>Srushti Patel</h2> */}
                                <img className="pg-img" src="srushti_patel.gif" alt="Loading..." />
                                <p className='pro-p'>Tools Used: HTML, CSS, JavaScript<br/>
                                    Description: Designed and developed a personal portfolio website to showcase skills, projects, and experience. Built using HTML, CSS, and JavaScript, ensuring a responsive and visually appealing design that effectively highlights professional accomplishments.​
                                </p>
                            </ProjectPopup>
                            
                            {/* <li className="post post-categories" data-category="Brand">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="ingenious_architectso_logo.png" alt="Loading..." onClick={() => togglePopup('project23')} />
                                    </figure>
                                </article>
                            </li>
                            <ProjectPopup isOpen={openProject === 'project23'} onClose={() => togglePopup('project23')}> */}
                                {/* <h2>Ingenious Architects</h2> */}
                                {/* <img className="pg-img" src="ingenious_architechso_logo.png" alt="Loading..." />
                            </ProjectPopup> */}

                            <li className="post post-categories" data-category="Brand">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="ingenious_crafting_logo.png" alt="Loading..." style={{ border: '0.5px solid #749ba8' }} onClick={() => togglePopup('project23')} />
                                    </figure>
                                </article>
                            </li>
                            <ProjectPopup isOpen={openProject === 'project23'} onClose={() => togglePopup('project23')}>
                                {/* <h2>Ingenious Architects</h2> */}
                                <img className="pg-img" src="ingenious_crafting_logo.png" alt="Loading..." />
                            </ProjectPopup>

                            <li className="post post-categories" data-category="Animation">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="sky.gif" alt="Loading..." onClick={() => togglePopup('project25')}/>
                                    </figure>
                                </article>
                            </li>
                            <ProjectPopup isOpen={openProject === 'project25'} onClose={() => togglePopup('project8')}>
                                {/* <h2>Sky Animation</h2> */}
                                <img className="pg-img" src="sky.gif" alt="Loading..." />
                                <p className='pro-p'>Tools Used: Adobe Premiere Pro<br/>
                                    Responsibility: Created smooth and visually appealing animated cloud effects using Adobe Premiere Pro, enhancing the overall aesthetic and atmosphere of the project.
                                </p>
                            </ProjectPopup>
                            
                            <li className="post post-categories" data-category="Design">
                                 <article>
                                     <figure>
                                        <img className="pg-img" src="hello_foody.png" alt="Loading..." onClick={() => togglePopup('project28')} />
                                     </figure>
                                 </article>
                             </li>
                            <ProjectPopup isOpen={openProject === 'project28'} onClose={() => togglePopup('project28')}>
                                {/* <h2>Ingenious Architects</h2> */}
                                <img className="pg-img" src="hello_foody.png" alt="Loading..." />
                            </ProjectPopup>

                            <li className="post post-categories" data-category="Design">
                                <article>
                                    <figure>
                                        <img className="pg-img" src="one5.gif" alt="Loading..." onClick={() => togglePopup('project27')} />
                                    </figure>
                                </article>
                            </li> 
                            <ProjectPopup isOpen={openProject === 'project27'} onClose={() => togglePopup('project27')}> 
                                {/* <h2>One5 Digital</h2> */}
                                <img className="pg-img" src="one5.gif" alt="Loading..." />
                                <p className='pro-p'>Tools Used: Adobe XD<br/>
                                    Description: Designed the company's website using Adobe XD. Focused on creating an engaging and intuitive user interface, enhancing the overall user experience.
                                </p>
                            </ProjectPopup>
                            
                        </ol>
                        </div>
                    </div>
                </div>
            </section>

            {/* Contact Section */}
            <section id="contact" className="contact-sec">
                <div className="cn-container">
                    <div className="cn-heading">
                        <h2 className="cn-head">CONTACT</h2>
                        <p className="cn-ph">Get in Touch
                            <span className="head-separator"></span>
                        </p>
                    </div>
                    <div className="con-container">
                        <div className="con-p1 order1">
                            <p className="cn-p">
                                <span className="cspan"><i class="fas fa-phone-alt"></i></span>
                                <a className="con-a" href="tel:2499790722">+1 (249) 979-0722</a>
                            </p>
                            <p className="cn-p2">
                                <span className="cspan"><i class="fas fa-envelope"></i></span>
                                <a href="mailto:shrupatel07@gmail.com" className="con-a">shrupatel07@gmail.com</a>
                            </p>
                            <h2 className="cnh2">Follow Me</h2>
                            <ul className="cnsocial">
                                <li className="cns-sites"><a className="cns-links" href="https://www.facebook.com/shrushti.7998" target="blank"><i class="fab fa-facebook-f "></i></a></li>
                                <li className="cns-sites"><a className="cns-links" href="https://www.linkedin.com/in/srushtipatel07/" target="blank"><i class="fab fa-linkedin-in "></i></a></li>
                                <li className="cns-sites"><a className="cns-links" href="https://github.com/shrush07" target="blank"><i class="fab fa-github "></i></a></li>
                                <li className="cns-sites"><a className="cns-links" href="https://twitter.com/Srushti_07" target="blank"><i class="fab fa-twitter"></i></a></li>
                            </ul>
                        </div>
                        <div className="con-p2 order0">
                            <h2 className="cnh">Send a note</h2>
                            <Form id="contact-form" onSubmit={sendEmail}>
                                <div className="con-row">
                                    <div className="cn-col">
                                        <input name="name" type="text" className="form-control" placeholder="Name" required />
                                    </div>
                                    <div className="cn-col">
                                        <input name="email" type="text" className="form-control" placeholder="Email" required />
                                    </div>
                                    <div className="cn-col">
                                        <input name="subject" type="text" className="form-control" placeholder="Subject" required />
                                    </div>
                                    <div className="cn-col">
                                        <input name="phone" type="tel" maxLength="10" className="form-control" placeholder="Contact Number" required />
                                    </div>
                                    <div className="cn-row">
                                        <textarea name="message" className="form-control" rows="5" placeholder="Send a message..." spellCheck="false" required></textarea>
                                    </div>
                                </div>
                                <p className="co-p">
                                    <Button id="submit-btn" className="btn" buttonStyle='btn--primary' buttonSize='btn--medium' type="submit">SEND MESSAGE</Button>
                                </p>
                            </Form>
                        </div>
                    </div>
                </div>
            </section>

            {/* <Chatbot /> */}
            {/* Footer Section */}
            <section id="footer" className="footer-sec">
                <div className="fr-container">
                    <div className="fr-row">
                        <div className="fr-det">
                            <p className="fr-p">2026 <a href="/" className="fr-a"><span className="fr-hspan">Srushti</span></a>.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default HeroSection
